import { render, staticRenderFns } from "./roommanagement.vue?vue&type=template&id=10634d70&scoped=true&"
import script from "./roommanagement.vue?vue&type=script&lang=js&"
export * from "./roommanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10634d70",
  null
  
)

export default component.exports